/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What's the difference between a nautical mile and a regular mile?`)
};

const es_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es la diferencia entre una milla náutica y una milla regular?`)
};

const de_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist der Unterschied zwischen einer Seemeile und einer gewöhnlichen Meile?`)
};

const nl_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is het verschil tussen een zeemijl en een gewone mijl?`)
};

const fr_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle est la différence entre un mille nautique et un mile régulier ?`)
};

const it_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è la differenza tra un miglio nautico e un miglio normale?`)
};

const pt_br2_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre uma milha náutica e uma milha comum?`)
};

const pt_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é a diferença entre uma milha náutica e uma milha regular?`)
};

const ja_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`海里と通常のマイルの違いは何ですか?`)
};

const zh_uc_len_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[pending translation]`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const uc_len_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.uc_len_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("uc_len_faq3_q", locale)
	if (locale === "en") return en_uc_len_faq3_q(inputs)
	if (locale === "es") return es_uc_len_faq3_q(inputs)
	if (locale === "de") return de_uc_len_faq3_q(inputs)
	if (locale === "nl") return nl_uc_len_faq3_q(inputs)
	if (locale === "fr") return fr_uc_len_faq3_q(inputs)
	if (locale === "it") return it_uc_len_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_uc_len_faq3_q(inputs)
	if (locale === "pt") return pt_uc_len_faq3_q(inputs)
	if (locale === "ja") return ja_uc_len_faq3_q(inputs)
	return zh_uc_len_faq3_q(inputs)
};